import PageHero from "@/components/site/PageHero";
import { useSEO } from "@/lib/seo";
import { useSiteSettings } from "@/lib/settings";
import { renderRichParagraphs } from "@/lib/cms-defaults";

const FALLBACK = `**1. Acceptance.** By using this website, you agree to these Terms of Use. If you do not agree, please discontinue use.

**2. Use of content.** Content on this website is owned by PharmacoHires and provided for personal, non-commercial use. You may not reproduce or redistribute content without written permission.

**3. Submissions.** By submitting a resume or any form, you confirm the information is accurate and that you have the right to share it. You grant us a limited licence to use this data for recruitment purposes as described in our Privacy Policy.

**4. No fees from candidates.** PharmacoHires never charges candidates any fee at any stage. If you encounter someone claiming otherwise on our behalf, please report it.

**5. Third-party links.** Our site may contain links to third-party websites. We are not responsible for their content or privacy practices.

**6. Disclaimers.** The website is provided on an "as is" basis. While we strive for accuracy, we make no warranties about the completeness or reliability of information.

**7. Limitation of liability.** To the maximum extent permitted by law, PharmacoHires shall not be liable for any indirect, incidental, or consequential damages arising from use of this website.

**8. Governing law.** These terms are governed by the laws of India, subject to the exclusive jurisdiction of the courts of Hyderabad.

**9. Contact.** Questions? Email <a href="mailto:careers@pharmacohires.com">careers@pharmacohires.com</a>.`;

export default function Terms() {
  useSEO({ title: "Terms of Use", description: "Terms governing the use of the PharmacoHires website.", pageKey: "terms" });
  const { settings } = useSiteSettings();
  const raw = (settings?.terms_content || "").trim() || FALLBACK;
  return (
    <>
      <PageHero overline="Legal" title="Terms of Use" />
      <section className="section-pad">
        <div className="container-page prose-pharma max-w-3xl" data-testid="terms-content">
          {renderRichParagraphs(raw)}
        </div>
      </section>
    </>
  );
}
